export default function getSearchLocationUtil () {
  return window.location.search
}
